<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="currentTab" :stepTitle="stepTitle"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <!-- <PublishHelper></PublishHelper> -->
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格日历</span>
              <span class="card-txt" v-if="optionName">
                <span v-if="catalogId==1">票型名称</span>
                <span v-if="catalogId==2">房型名称</span>
                <span v-else>套餐名称</span>：
                {{ optionName }}</span>
            </a-col>
          </a-row>
          <a-row :span="24">
            <a-col :span="14" style="position: relative">
              <a-tabs type="card" v-model="ratePlanId" @change="callPlanPriceBack" style="max-width: 1072px;">
                <a-tab-pane v-for="item in planPriceList" :key="item.ratePlanId" :tab="item.ratePlanName"></a-tab-pane>
              </a-tabs>
              <a-calendar :mode="mode" @panelChange="onPanelChange" @select="onDateSelected"
                          :disabledDate="disabledDate">
                <div style="width: 100%;" slot="dateCellRender" slot-scope="value">
                  <a-checkbox v-if="!isDisabledDate(value)&&!getDisabledDate(value)"
                              class="item-checkbox" :checked="isSelected(value)" style="width: 40px">
                  </a-checkbox>
                  <div v-for="item in getListData(value)" :key="item.content" style="font-size: 12px">
                    {{ item.content }}
                  </div>
                </div>
              </a-calendar>
              <a-checkbox v-model="selectedAll" class="all-select" :disabled="disabledAll" @change="selectedAllDate">
                全选
              </a-checkbox>
              <a-row>
                <a-button type="primary" ghost @click="popupVisible = true">批量设置</a-button>
                <!--                <a-button type="danger" class="ml15" ghost @click="clearAllData">全部清空</a-button>-->
              </a-row>
            </a-col>
            <a-col :span="10" v-if="catalogId==1||catalogId==2||catalogId==4" style="padding-top: 40px;">
              <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{span:9}"
                            :wrapper-col="{span:15}">
                <a-row :span="10">
                  <a-col :span="12">
                    <a-form-model-item label="同行价" prop="mfAuditPrice">
                      <a-input v-model="ruleForm.mfAuditPrice" placeholder="请输入" addon-after="元"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="建议销售价" prop="advicePrice">
                      <a-input v-model="ruleForm.advicePrice" placeholder="请输入" addon-after="元"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :span="10">
                  <a-col :span="12">
                    <a-form-model-item label="市场价" prop="marketPrice">
                      <a-input v-model="ruleForm.marketPrice" placeholder="请输入" addon-after="元"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="分销佣金" prop="commissionPrice">
                      <a-input v-model="ruleForm.commissionPrice" placeholder="请输入" addon-after="元"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :span="10">
                  <a-col :span="12">
                    <a-form-model-item label="采购价" prop="purchasePrice">
                      <a-input v-model="ruleForm.purchasePrice" placeholder="请输入" addon-after="元"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :span="10">
                  <a-col :span="12">
                    <a-form-model-item label="分销改价权限">
                      <a-select v-model="ruleForm.priceDistAdjust" placeholder="请选择">
                        <a-select-option :value="1">不可调整</a-select-option>
                        <a-select-option :value="2">不可低于建议销售价</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="是否二次确认">
                      <a-select v-model="ruleForm.isConfirm" placeholder="请选择">
                        <a-select-option :value="0">不需要二次确认</a-select-option>
                        <a-select-option :value="1">需要二次确认</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :span="10">
                  <a-col :span="12">
                    <a-form-model-item label="库存" prop="stock">
                      <a-input v-model="ruleForm.stock" placeholder="请输入库存"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :span="10">
                  <a-col :span="18">
                    <a-form-model-item :wrapper-col="{offset: 7 }">
                      <a-button type="primary" :disabled="submitDis" @click="onSubmit" :loading="submitLoading">保存
                      </a-button>
                      <a-popconfirm v-if="selectedDateList && selectedDateList.length>0" style="margin-left: 10px"
                                    title="是否要删除当前价格？" @confirm="deleteEvent">
                        <a-button type="danger" :disabled="submitDis" :loading="delLoading">删除</a-button>
                      </a-popconfirm>
                      <a-button @click="resetForm" :disabled="submitDis" style="margin-left: 10px">重置</a-button>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </a-col>
            <a-col :span="9" v-else>
              <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{span:5}"
                            :wrapper-col="{span:19}">
                <a-form-model-item label="同行价" required class="mb0">
                  <a-form-model-item prop="mfAuditPrice" class="inline mr15">
                    <a-input v-model="ruleForm.mfAuditPrice" placeholder="请输入成人同行价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="mfAuditChildren" class="inline">
                    <a-input v-model="ruleForm.mfAuditChildren" placeholder="请输入儿童同行价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="建议销售价" required class="mb0">
                  <a-form-model-item prop="advicePrice" class="inline mr15">
                    <a-input v-model="ruleForm.advicePrice" placeholder="请输入成人销售价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="adviceChildPrice" class="inline">
                    <a-input v-model="ruleForm.adviceChildPrice" placeholder="请输入儿童销售价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="分销佣金" class="mb0">
                  <a-form-model-item prop="commissionPrice" class="inline mr15">
                    <a-input v-model="ruleForm.commissionPrice" placeholder="请输入成人佣金"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="commissionChildPrice" class="inline">
                    <a-input v-model="ruleForm.commissionChildPrice" placeholder="请输入儿童佣金"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="市场价" required class="mb0">
                  <a-form-model-item prop="marketPrice" class="inline mr15">
                    <a-input v-model="ruleForm.marketPrice" placeholder="请输入成人市场价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="childMarketPrice" class="inline">
                    <a-input v-model="ruleForm.childMarketPrice" placeholder="请输入儿童市场价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="采购价" required class="mb0">
                  <a-form-model-item prop="purchasePrice" class="inline mr15">
                    <a-input v-model="ruleForm.purchasePrice" placeholder="请输入成人采购价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="purchaseChildprice" class="inline">
                    <a-input v-model="ruleForm.purchaseChildprice" placeholder="请输入儿童采购价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="单房差" prop="priceDifferenceRoom">
                  <a-input v-model="ruleForm.priceDifferenceRoom" placeholder="请输入单房差"></a-input>
                </a-form-model-item>
                <a-form-model-item label="分销价格权限">
                  <a-select v-model="ruleForm.priceDistAdjust" placeholder="请选择">
                    <a-select-option :value="1">不可调整</a-select-option>
                    <a-select-option :value="2">不可低于建议销售价</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="是否二次确认">
                  <a-select v-model="ruleForm.isConfirm" placeholder="请选择">
                    <a-select-option :value="0">不需要</a-select-option>
                    <a-select-option :value="1">需要</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="库存" prop="stock">
                  <a-input v-model="ruleForm.stock" placeholder="请输入库存"></a-input>
                </a-form-model-item>
                <a-form-model-item label="预警" prop="warning">
                  <a-input v-model="ruleForm.warning" placeholder="请输预警值"></a-input>
                </a-form-model-item>
                <div style="text-align: center">
                  <a-button type="primary" :disabled="submitDis" @click="onSubmit" :loading="submitLoading">保存
                  </a-button>
                  <a-popconfirm v-if="selectedDateList && selectedDateList.length>0" style="margin-left: 10px"
                                title="是否要删除当前价格？" @confirm="deleteEvent">
                    <a-button type="danger" :disabled="submitDis" :loading="delLoading">删除</a-button>
                  </a-popconfirm>
                  <a-button @click="resetForm" :disabled="submitDis" style="margin-left: 10px">重置</a-button>
                </div>
              </a-form-model>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </div>
    <PriceVolumeSet :visible="popupVisible" :proId="proId" :optionId="optionId"
                    :ratePlanId="ratePlanId"
                    @changeClose="changePriceClose" @changeUpdate="changePriceUpdate"></PriceVolumeSet>
    <CommissionComponent
      :priceDataList="priceDataList"
      :selectedDateList="selectedDateList"
      :proCatalog="catalogId"
      :optionId="optionId"
      :ratePlanId="ratePlanId"
      :proId="proId"
    ></CommissionComponent>
  </div>
</template>

<script>
import ProductHeader from './ProductHeader'
import PublishHelper from './PublishHelper'
import PriceVolumeSet from './PriceVolumeSet'
import CommissionComponent from '@/views/product/components/CommissionComponent'
import moment from 'moment'

export default {
  name: 'NewProCalendar',
  components: {
    ProductHeader,
    PublishHelper,
    PriceVolumeSet,
    CommissionComponent
  },
  data() {
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.mfAuditPrice)) {
          callback(new Error('销售价大于或等于同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkAdviceChildPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.mfAuditChildren)) {
          callback(new Error('销售价大于或等于同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCommissionPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Math.round(Math.round(Number(this.ruleForm.advicePrice) * 100) - Math.round(Number(this.ruleForm.mfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于销售价减同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCommissionChildPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Math.round(Math.round(Number(this.ruleForm.adviceChildPrice) * 100) - Math.round(Number(this.ruleForm.mfAuditChildren) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于销售价减同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkWarning = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(this.ruleForm.stock) < Number(value)) {
          callback(new Error('预警值不能大于库存'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      ratePlanId: Number(this.$route.query.ratePlanId),
      optionName: this.$route.query.optionName,
      ruleForm: {
        adviceChildPrice: '', //建议销售儿童价
        advicePrice: '', //建议销售价;建议销售成人价
        childMarketPrice: '', //市场儿童价
        commissionPrice: '', //佣金
        commissionChildPrice: '', //儿童价佣金
        dates: '', //日期
        isConfirm: 1, // 是否需要再次确认 0 不需要 1 需要 ,
        marketPrice: '', //市场价 ;市场成人价 ,
        merchantId: 0, //商户Id
        mfAuditChildren: '', //儿童同行价
        priceDistAdjust: 1, // 分销价格调整权限 0 自有调整 1 不可调整 2 不可低于建议销售价 ,
        mfAuditPrice: '', //同行价;成人同行价 ,
        optionId: this.$route.query.optionId, //
        proId: this.$route.query.proId,
        ratePlanId: this.$route.query.ratePlanId,
        purchaseChildprice: '', //采购儿童价
        purchasePrice: '', //采购价;采购成人价
        stock: '', //库存
        warning: '', //警告
        priceDifferenceRoom: '' //单房差
      },
      submitLoading: false,
      delLoading: false,
      submitFormData: '',
      rules: {
        mfAuditPrice: [
          { required: true, message: '请输入同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        advicePrice: [
          { required: true, message: '请输入建议销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkAdvicePrice, trigger: 'blur' }
        ],
        marketPrice: [
          { required: true, message: '请输入市场价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        purchasePrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        mfAuditChildren: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        adviceChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkAdviceChildPrice, trigger: 'blur' }
        ],
        childMarketPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        purchaseChildprice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        commissionPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        commissionChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkCommissionChildPrice, trigger: 'blur' }
        ],
        priceDifferenceRoom: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ],
        warning: [
          { pattern: /^[0-9]\d{0,3}$/, message: '请输入正确的预警', trigger: 'blur' },
          { validator: checkWarning, trigger: 'blur' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      mode: 'month',
      selectedAll: false,
      submitDis: false,
      disabledAll: false,
      priceDataList: [],
      selectedDateList: [],
      monthStr: '',
      stepTitle: '',
      currentTab: 1.4,
      planPriceList: [],
      popupVisible: false
    }
  },
  mounted() {
    this.monthStr = this.getDateHelper().getCurrentFormatDate('YYYY-MM')
    this.currentTab = (this.catalogId == 73 || this.catalogId == 74) ? 3.1 : 1.4
    this.getProPriceInfo()
    this.getPlanPriceList()
    if (this.catalogId == 1) {
      this.stepTitle = '票型及价格'
    } else if (this.catalogId == 2) {
      this.stepTitle = '房型/价格计划'
    } else if (this.catalogId == 4) {
      this.stepTitle = '套餐及价格'
    } else if (this.catalogId == 75) {
      this.stepTitle = '图文详情及价格'
    } else {
      this.stepTitle = '套餐/价格/库存'
    }
  },
  watch: {
    selectedDateList: function(dateList) {
      if (dateList && dateList.length > 0) {
        //自动填充选中的第一个日期的价格
        const firstDate = dateList[0]
        this.getLogUtils().logWithTag('==selectedDateList-dateList', dateList)
        this.getLogUtils().logWithTag('==selectedDateList1', firstDate)
        let selectedPriceItem = this.priceDataList.find((item, index, arr) => item.priceDate === firstDate)
        if (selectedPriceItem) {
          this.ruleForm = selectedPriceItem
          this.getLogUtils().logWithTag('==selectedDateList2', this.ruleForm)
        }
      }
    }
  },
  methods: {
    //批量清空
    clearAllData() {
      let that = this
      this.$confirm({
        title: '此操作将清空该酒店价格计划下的价格信息, 是否继续?',
        onOk() {
          that.onClearEventData()
        },
        onCancel() {
          that.$message.warning('已取消')
        }
      })
    },
    //清空日历接口
    onClearEventData() {
      let params = {
        productId: this.proId,
        optionId: this.optionId,
        ratePlanId: this.ratePlanId
      }
      this.getHttpServices().getProService().post('api/v2/productManage/hotel/price-plan/flush-delete', params).then(res => {
        this.getLogUtils().logWithTag('==onClearEventData', res)
        this.$message.success('全部清空价格成功')
        this.getProPriceInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //更新价格日历信息
    changePriceUpdate() {
      this.changePriceClose()
      this.getProPriceInfo()
    },
    //获取价格计划列表
    getPlanPriceList() {
      let params = {
        limitDto: {
          pageNum: 1,
          pageSize: 100
        },
        proId: this.$route.query.proId,
        optionId: this.$route.query.optionId
      }
      this.getHttpServices().getProService().post('api/v2/productManage/findRatePlanList', params).then(res => {
        this.getLogUtils().logWithTag('==getPlanPriceList', res)
        this.planPriceList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    changePriceClose() {
      this.popupVisible = false
    },
    //切换价格计划
    callPlanPriceBack(key) {
      this.getLogUtils().logWithTag('==callPlanPriceBack', key)
      this.ratePlanId = key
      this.ruleForm.ratePlanId = key
      this.getProPriceInfo()
    },
    getDisabledDate(current) {
      // this.getLogUtils().logWithTag('==isDisabledDate===',current)
      return current && current < moment().startOf('day')
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    //判断选项是否禁用(非当前月的数据禁用)
    isDisabledDate(value) {
      const dateStr = this.getDateHelper().formatDate(value, 'YYYY-MM')
      return dateStr !== this.monthStr
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
      if (this.catalogId == 1 || this.catalogId == 2 || this.catalogId == 4) {
        if (priceItem) {
          if (priceItem.mfAuditPrice) {
            listData.push({ type: 'success', content: '同行价    ¥' + priceItem.mfAuditPrice })
          }
          if (priceItem.advicePrice) {
            listData.push({ type: 'success', content: '销售价    ¥' + priceItem.advicePrice })
          }
          if (priceItem.purchasePrice) {
            listData.push({ type: 'success', content: '采购价    ¥' + priceItem.purchasePrice })
          }
          if (priceItem.stock) {
            listData.push({ type: 'success', content: '库存    ' + priceItem.stock })
          }
          if (priceItem.warning) {
            listData.push({ type: 'success', content: '预警值    ' + priceItem.warning })
          }
        }
      } else {
        if (priceItem) {
          if (priceItem.mfAuditPrice) {
            listData.push({ type: 'success', content: '成人同行价    ¥' + priceItem.mfAuditPrice })
          }
          if (priceItem.mfAuditChildren) {
            listData.push({ type: 'success', content: '儿童同行价    ¥' + priceItem.mfAuditChildren })
          }
          if (priceItem.advicePrice) {
            listData.push({ type: 'success', content: '成人销售价    ¥' + priceItem.advicePrice })
          }
          if (priceItem.adviceChildPrice) {
            listData.push({ type: 'success', content: '儿童销售价    ¥' + priceItem.adviceChildPrice })
          }
          if (priceItem.purchasePrice) {
            listData.push({ type: 'success', content: '成人采购价    ¥' + priceItem.purchasePrice })
          }
          if (priceItem.purchaseChildprice) {
            listData.push({ type: 'success', content: '儿童采购价    ¥' + priceItem.purchaseChildprice })
          }
          if (priceItem.stock) {
            listData.push({ type: 'success', content: '库存    ' + priceItem.stock })
          }
          if (priceItem.warning) {
            listData.push({ type: 'success', content: '预警值    ' + priceItem.warning })
          }
        }
      }
      return listData
    },
    onDateSelected(date) {
      this.getLogUtils().logWithTag('==onDateSelected mode===', this.mode)
      this.getLogUtils().logWithTag('==onDateSelected date===', date)
      if (this.mode === 'year') {
        this.mode = 'month'
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getProPriceInfo()
      } else {
        const dateStr = this.getDateHelper().getFormatDate(date)
        this.getLogUtils().logWithTag('==onDateSelected dateStr===', dateStr)
        if (this.isSelected(date)) {
          this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
        } else {
          this.selectedDateList.push(dateStr)
        }
      }
      this.getLogUtils().logWithTag('==onDateSelected dateStr===', this.selectedDateList)
    },
    isSelected(momentValue) {
      const dateStr = this.getDateHelper().getFormatDate(momentValue)
      const index = this.selectedDateList.findIndex((item, index, arr) => dateStr === item)
      return index >= 0
    },
    onPanelChange(date, mode) {
      this.mode = mode
      this.getLogUtils().logWithTag('===onPanelChange mode===', mode)
      this.getLogUtils().logWithTag('===onPanelChange date===', moment(date).format('YYYY-MM-DD'))
      // const diff = moment(date).diff(moment(moment().startOf('day').toDate()), 'days')
      // this.submitDis = diff<0?true:false;
      // this.getLogUtils().logWithTag('===onPanelChange diff1===',diff)
      if (mode === 'month') {
        this.selectedAll = false
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getLogUtils().logWithTag('===this.monthStr ===', this.monthStr)
        let nowMouth = moment(new Date()).format('YYYY-MM')
        let diffMonths = this.getDateHelper().diffMonths(nowMouth, this.monthStr)
        this.disabledAll = diffMonths >= 0 ? false : true
        this.getProPriceInfo()
      }
    },
    selectedAllDate: function(e) {
      if (e.target.checked) {
        const newList = []
        let days = this.getDateHelper().getDaysInMonth(this.monthStr + '-01')
        this.getLogUtils().logWithTag('days', days)
        for (let i = 1; i <= days; i++) {
          newList.push(this.monthStr + '-' + (i > 9 ? i : '0' + i))
        }
        let nowDate = moment(new Date()).format('YYYY-MM-DD')
        this.getLogUtils().logWithTag('===selectedAllDate nowDate===', nowDate)
        let index = newList.indexOf(nowDate)
        this.getLogUtils().logWithTag('index', index)
        if (index != -1) {
          this.selectedDateList = newList.slice(index, newList.length)
        } else {
          this.selectedDateList = newList
        }
      } else {
        this.selectedDateList = []
      }
      this.selectedAll = e.target.checked
      this.getLogUtils().logWithTag('selectedAllDate', e.target.checked)
      this.getLogUtils().logWithTag('==selectedAllDate dateListStr===', this.selectedDateList)
    },
    checkForm() {
      if (this.selectedDateList.length < 1) {
        this.$message.error('请选择日期')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.submitFormData.dates = this.selectedDateList.join(',')
      this.getHttpServices().getProService().post('priceCalendar/savePriceCalendarSelfOwned', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('价格日历设置成功')
        this.getProPriceInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取全月的接口
    getProPriceInfo() {
      this.getHttpServices().getProService().post('priceCalendar/fullMonthPrice', {
        optionId: this.optionId,
        proId: this.proId,
        startDateStr: this.monthStr + '-01',
        ratePlanId: this.ratePlanId
      }).then(res => {
        this.getLogUtils().logWithTag('getProPriceInfo', res)
        this.priceDataList = res.calendarDayVOs
        this.selectedDateList = []
        this.selectedAll = false
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 删除价格信息
    deleteEvent() {
      this.ruleForm.dates = this.selectedDateList.join(',')
      this.delLoading = true
      this.getHttpServices().getProService().post('priceCalendar/deletePriceCalendar', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('deleteEvent', res)
        this.$message.success('删除日历成功')
        this.getProPriceInfo()
        this.resetForm()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.delLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex: 1;

      .inline {
        display: inline-block;

        input {
          max-width: 160px;
        }
      }

      .ml15 {
        margin-left: 15px;
      }

      .mr15 {
        margin-right: 5px;
      }

      .mb0 {
        margin-bottom: 0;
      }
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

.all-select {
  position: absolute;
  right: 320px;
  top: 72px;
}
</style>
<style lang="less">
.page-box {
  .selected-color {
    background-color: #e6f7ff;
  }

  .ant-card-body {
    padding-top: 1px;
  }

  .item-checkbox {
    position: absolute;
    top: 6px;
  }

  .ant-fullcalendar table {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 125px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-content {
    height: 92px;
  }
}
</style>